import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginBgImage from "../../../assets/img/login-bg-1.jpg";

const Login = ({ authenticate }) => {
  // auth
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // auth

  const handleLoginOnClick = (e) => {
    e.preventDefault();
    setErrorMsg("");
    // authenticate();
    // navigate("add-table");
    // return ;

    // login check
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };
    setLoading(true);
    // console.log(this.formData);
    axios
      .post(
        "/login",
        {
          email: email,
          password: password,
          dentrino_clinic_id: pin,
        },
        axiosConfig
      )
      .then((res) => {
        setErrorMsg("");
        setLoading(false);
        console.log(res);
        console.log(res?.data?.token);
        authenticate(res?.data);
        navigate("/");

        // this.setFeedback(res.data.feedback);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error paise", error);
        const errors = error.response.data.message;
        let errorMsg = "";
        for (const err in errors) {
          errorMsg = errorMsg + " " + errors[err];
        }

        // this.setFeedback(feedbackData);
        console.log("err-", errorMsg);
        setErrorMsg(errorMsg);
      })
      .finally(() => setLoading(false));
    // login check
  };

  const validateUser = () => {
    // set toakn to localStorage
    // set
  };
  // const normalise = (value) => ((value - MIN) * 100) / (MAX - MIN);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(${LoginBgImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Paper sx={{ p: 4, zIndex: 2, boxShadow: 3 }}>
        <Box sx={{ fontSize: "2rem", pb: 3 }}>Dentrino Login</Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            sx={{ mx: 1 }}
            //   size="small"
            label="Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          <TextField
            sx={{ mx: 1 }}
            //   size="small"
            label="Password"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          <TextField
            sx={{ mx: 1, width: "150px" }}
            //   size="small"
            label="PIN"
            type="number"
            onChange={(e) => setPin(e.target.value)}
            value={pin}
          />
          {loading ? (
            // <CircularProgress />
            <Box sx={{ display:"flex", alignItems:"center",  px: 5 }}>
              <CircularProgress size={40} sx={{px:2}} />
              Authenticating...
            </Box>
          ) : (
            <Button
              color="success"
              variant="contained"
              size="large"
              onClick={handleLoginOnClick}
            >
              Login
            </Button>
          )}
        </Box>
        {errorMsg && (
          <Box
            sx={{
              dispaly: "flex",
              justifyContent: "center",
              pt: 4,
              px: 3,
              pb: 1,
            }}
          >
            <Alert severity="error">{errorMsg}</Alert>
          </Box>
        )}
      </Paper>
      <Box
        sx={{
          position: "absolute",
          bgcolor: "black",
          height: "100%",
          width: "100%",
          zIndex: 1,
          opacity: 0.4,
        }}
      ></Box>
    </Box>
  );
};

export default Login;
